// src/App.js
import React, { useEffect } from "react";
import "./App.scss";
import { requestPermission } from "./firebase";
import PushManager from "./components/PushManager";

function App() {
  useEffect(() => {
    // Ask for notification permission when app loads
    requestPermission();
  }, []);

  return (
    <div className="app-container">
      <PushManager />

      <header>
        <h1>Welcome to FlamoPay 🚀</h1>
        <p>Earn rewards by socialising, posting, reacting, and referring friends!</p>
      </header>

      <main>
        <section className="hero">
          <h2>Hello, [Username]!</h2>
          <p>Connect with others and earn points for every post, comment, and share.</p>
        </section>

        <section className="stats-panel">
          <div className="stat-card">Total Earnings: 0 Points</div>
          <div className="stat-card">Posts Created: 0</div>
          <div className="stat-card">Reactions Given: 0</div>
          <div className="stat-card">Referral Earnings: 0 Points</div>
        </section>

        <section className="rewards-info">
          <h3>🎉 Reward System</h3>
          <ul>
            <li>🆕 50 points — Welcome bonus for new users</li>
            <li>👫 100 points — For every friend you refer</li>
            <li>💬 Earn by posting, liking, commenting, and sharing</li>
          </ul>
        </section>

        <section className="quick-buttons">
          <button>Start Socialising</button>
          <button>View Leaderboard</button>
          <button>Withdraw Points</button>
        </section>

        <section className="leaderboard">
          <h3>Top Earners</h3>
          <ul>
            <li>1. UserA - 5000 Points</li>
            <li>2. UserB - 4200 Points</li>
            <li>3. UserC - 3800 Points</li>
          </ul>
        </section>

        <section className="notifications">
          <h3>Recent Activity</h3>
          <ul>
            <li>🎁 50 points welcome bonus has been added</li>
            <li>👫 You earned 100 points from a referral!</li>
          </ul>
        </section>

        <section className="push-status">
          <p>🔔 Notifications are enabled — you’ll receive updates in real time.</p>
        </section>
      </main>

      <footer>
        <p>Quick Links:</p>
        <ul>
          <li>Home</li>
          <li>About</li>
          <li>Contact</li>
          <li>Legal</li>
          <li>Privacy Policy</li>
          <li>Terms of Service</li>
          <li>Cookie Policy</li>
          <li>Support</li>
          <li>Help Center</li>
          <li>FAQ</li>
          <li>System Status</li>
        </ul>

        <div className="social-media">
          <a
            href="https://www.facebook.com/share/1LMzW3eRjq/"
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
